import React, { useCallback, useEffect, useRef, useState } from 'react';

const Checkbox = ({
  fieldName,
  wrapperClass = '',
  label = '',
  allowNull = true,
  value,
  errors = [],
  helpText = '',
  additionalClass = '',
  parent = '',
  onChange = () => {},
  pk = null,
  disabled = false
}) => {
  const didRegisterDefaultRef = useRef(false);
  const [inputValue, setInputValue] = useState((value === true || value === 'on') ? true : false);

  // Keep local checked state in sync with upstream value changes.
  useEffect(() => {
    setInputValue(value === true || value === 'on');
  }, [value]);

  // Ensure unchecked checkboxes still submit a value.
  useEffect(() => {
    if (didRegisterDefaultRef.current) return;
    if (value !== undefined && value !== null && value !== '') return;

    didRegisterDefaultRef.current = true;
    onChange({ name: fieldName, value: 'off', checked: false, label: 'off' });
  }, [fieldName, onChange, value]);

  const localOnChange = useCallback((e) => {
    const checked = Boolean(e.target.checked);
    const nextValue = checked ? 'on' : 'off';
    setInputValue(checked);
    onChange({ name: fieldName, value: nextValue, checked, label: nextValue });
  }, [fieldName, onChange])

return (<>
      <input
        type="hidden"
        name={fieldName}
        value="off"
        // disabled={isDisabled}
      />
      <input
        id={pk ? pk + '_' + fieldName : fieldName}
        className={`form-check-input d-block mb-2 ${additionalClass} ${errors.length > 0 ? 'has-error is-invalid' : ''}`}
        checked={inputValue}
        name={fieldName}
        type="checkbox"
        role="switch"
        data-bool_select_parent={parent}
        onChange={localOnChange}
        disabled={disabled}
      />
    </>
  );
};

export default Checkbox;
